'use strict';

var Modal = require('./modal');
var blzEvent = require('../services/tracking/blz-event.js');
var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');

var ModalIframe = {
  openBlogModal: function openModalLoucas(event) {
    ModalIframe.openModal(
      event,
      this,
      '?webview=true&hideshare=true',
      'Loucas Por Beleza',
      '-Loucas'
    );
  },
  openModal: function openModal(event, that, urlParam, modalTitle, eventLabel) {
    event && event.preventDefault();
    var $this = that ? $(that) : $(this);
    var destination = $this.attr('href') + urlParam || '';
    var iframe =
      '<iframe class="modal-iframe" id="js-modal-window" src="' +
      destination +
      '" frameborder="0" allowfullscreen="allowfullscreen"></iframe>';

    blzEvent.interaction(event, {
      category: (blz.pageName || '').toUpperCase(),
      action: 'Link-Click',
      label: 'Open-Modal-Iframe' + eventLabel || ''
    });

    Modal.open({
      title: modalTitle || $this.attr('title') || 'Beleza na Web',
      body: iframe,
      windowTopClass: 'modal-without-padding',
      onClose: function () {
        blzEvent.interaction(event, {
          category: 'PRODUCT',
          action: 'Button-Click',
          label: 'Exit-Modal-Iframe' + eventLabel || ''
        });
      }
    });
  },
  openContent: function openContent(event, that, urlParam, modalTitle, eventLabel, onOpen) {
    event && event.preventDefault();
    var $this = that ? $(that) : $(this);
    var destination = $this.attr('href') + urlParam || '';

    blzEvent.interaction(event, {
      category: (blz.pageName || '').toUpperCase(),
      action: 'Link-Click',
      label: 'Open-Modal-Content' + eventLabel || ''
    });

    HTTPService.get(destination)
      .then(HTTPService.handleClientError)
      .then(function (content) {
        Modal.open({
          title: modalTitle || $this.attr('title') || 'Beleza na Web',
          windowTopClass: 'modal-without-padding',
          body: content,
          onClose: function () {
            blzEvent.interaction(event, {
              category: 'PRODUCT',
              action: 'Button-Click',
              label: 'Exit-Modal-Content' + eventLabel || ''
            });
          },
          onOpen: function () {
            onOpen ? onOpen() : null;
          }
        });
      })
      .catch(NotificationService.warning);
  },
  openContentKerastase: function openContentKerastase(event) {
    ModalIframe.openContent(
      event,
      this,
      '',
      'Descubra o seu tratamento',
      '',
      blz.reactApps.QuizKerastase
    );
  }
};

$('body').on('click tap', '.js-blog-posts', ModalIframe.openBlogModal);
$('body').on(
  'click tap',
  'a[href*="/api/htmls/modal/kerastase"]',
  ModalIframe.openContentKerastase
);

module.exports = ModalIframe;
